// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Button from "../../library/Button.bs.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as PhoneField from "../../forms/PhoneField.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as FormHelpers from "../../../utils/FormHelpers.bs.js";
import * as FormReducer from "../../../utils/FormReducer.bs.js";
import * as $$Notification from "../../library/Notification.bs.js";
import * as ReactHookForm from "../../../bindings/ReactHookForm.bs.js";
import * as ReactHookForm$1 from "react-hook-form";
import * as OnboardingLayout from "../../../layouts/OnboardingLayout.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeeSecureClient from "../../../api/PrezzeeSecureClient.bs.js";
import * as ForgotEmailOnboardingStyles from "./ForgotEmailOnboardingStyles.bs.js";
import * as OnboardingLayoutCreateAccountButton from "../../library/OnboardingLayoutCreateAccountButton.bs.js";

function ForgotEmailOnboarding(props) {
  var match = FormReducer.useFormReducer(undefined);
  var dispatch = match[1];
  var state = match[0];
  var form = ReactHookForm.useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: {
          phoneNumber: null
        }
      }, undefined);
  var phoneControllerOptions = FormHelpers.getPhoneControllerOptions(form.control, "phoneNumber", true);
  var match$1 = ReactHookForm$1.useController(phoneControllerOptions);
  var match$2 = match$1.field;
  var phoneError = FormHelpers.getPhoneError(form.errors, match$2.value);
  var match$3 = React.useState(function () {
        return true;
      });
  var setCanSubmit = match$3[1];
  var onSubmit = React.useCallback((function (data) {
          var phone = FormHelpers.getPhoneNumber(data.phoneNumber);
          Curry._1(dispatch, /* Submit */0);
          Curry._1(setCanSubmit, (function (param) {
                  return false;
                }));
          setTimeout((function (param) {
                  Curry._1(setCanSubmit, (function (param) {
                          return true;
                        }));
                }), 60000);
          Js_promise.then_((function (result) {
                  var tmp;
                  if (result.TAG === /* Ok */0) {
                    tmp = Curry._1(dispatch, /* Error */{
                          _0: {
                            TAG: /* ShowNotificationSuccess */0,
                            _0: "Request successful",
                            _1: "An SMS with your email address has been sent to the mobile number attached to your account."
                          }
                        });
                  } else {
                    var e = result._0;
                    Curry._1(setCanSubmit, (function (param) {
                            return true;
                          }));
                    switch (e.TAG | 0) {
                      case /* NetworkError */0 :
                      case /* JsonParsingError */1 :
                          tmp = Curry._1(dispatch, /* Error */{
                                _0: /* ShowNotificationError */0
                              });
                          break;
                      case /* ServerError */2 :
                          var serverError = e._0;
                          tmp = typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */0 ? Curry._1(dispatch, /* Error */{
                                  _0: /* ShowNotificationError */0
                                }) : Curry._1(dispatch, /* Error */{
                                  _0: {
                                    TAG: /* ShowPhoneNumberError */1,
                                    _0: serverError._0
                                  }
                                });
                          break;
                      
                    }
                  }
                  return Promise.resolve(tmp);
                }), PrezzeeSecureClient.forgotEmailAddress(phone));
        }), []);
  var notification = state.error;
  var tmp;
  tmp = notification !== undefined ? (
      typeof notification === "number" ? JsxRuntime.jsx($$Notification.make, {
              notificationType: /* NotificationError */0,
              title: "An error occured",
              description: "We could not send you an SMS to complete your request. Please try again later."
            }) : (
          notification.TAG === /* ShowNotificationSuccess */0 ? JsxRuntime.jsx($$Notification.make, {
                  notificationType: /* NotificationSuccess */2,
                  title: notification._0,
                  description: notification._1
                }) : JsxRuntime.jsx($$Notification.make, {
                  notificationType: /* NotificationError */0,
                  title: "Invalid phone number",
                  description: notification._0
                })
        )
    ) : null;
  return JsxRuntime.jsxs(OnboardingLayout.make, {
              children: [
                JsxRuntime.jsx(OnboardingLayoutCreateAccountButton.make, {}),
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: ForgotEmailOnboardingStyles.notificationContainer
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h1", {
                              children: Util.ReactStuff.s("Forgot your email?"),
                              className: ForgotEmailOnboardingStyles.titleStyle
                            }),
                        JsxRuntime.jsx("h2", {
                              children: Util.ReactStuff.s("Please enter the mobile number associated with your account."),
                              className: ForgotEmailOnboardingStyles.subtitleStyle
                            }),
                        JsxRuntime.jsxs("form", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(PhoneField.TSXComponent.make, {
                                            error: Belt_Option.getWithDefault(phoneError, ""),
                                            fieldOnChange: match$2.onChange
                                          }),
                                      className: "text-left"
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s("Send me a code"),
                                      className: Cn.make([
                                            ForgotEmailOnboardingStyles.submitBtnStyle,
                                            match$3[0] && !state.isSubmitting ? Button.primaryStyle : Button.disabled
                                          ]),
                                      disabled: state.isSubmitting,
                                      type: "submit"
                                    })
                              ],
                              onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                            })
                      ],
                      className: ForgotEmailOnboardingStyles.mainContainer
                    })
              ],
              onboardingKind: /* ShowAppDownload */1
            });
}

var Link;

var make = ForgotEmailOnboarding;

var $$default = ForgotEmailOnboarding;

export {
  Link ,
  make ,
  $$default ,
  $$default as default,
}
/* Util Not a pure module */
